import { render, staticRenderFns } from "./SwitchChart.vue?vue&type=template&id=d79aaaa4&"
import script from "./SwitchChart.vue?vue&type=script&lang=js&"
export * from "./SwitchChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports